module.exports = __webpack_public_path__ + "img/no-team-activity-hours.48ccfd80.png";